import { Payments } from "@/constants";
import { PaymentInfo, PaymentItem, payments } from "@/constants/payment/types";
import { cn, createBEM } from "@/libs";
import { SwipeAction } from "antd-mobile";
import { Action } from "antd-mobile/es/components/swipe-action";
import { useMemo } from "react";
import { AlipayItem } from "../AlipayItem";
import { BankItem } from "../BankItem";
import { WechatItem } from "../WechatItem";
import "./index.scss";
import { USDTItem } from "../USDTItem";
import { DigitalRMBItem } from "../DigitalRMBItem";
export type RenderPayment = PaymentInfo & PaymentItem;
const paymentItemMap: Record<string, (props: any) => JSX.Element> = {
  [`${Payments.ALI}`]: AlipayItem,
  [`${Payments.BANK}`]: BankItem,
  [`${Payments.WE_CHAT}`]: WechatItem,
  [`${Payments.CRYPTO_COIN}`]: USDTItem,
  [`${Payments.DIGITAL_RMB}`]: DigitalRMBItem
};
const rightActions: Action[] = [{
  key: "unbind",
  text: "解绑",
  color: "danger"
}];
export const RenderItem = ({
  item,
  index,
  onAction
}: {
  item: RenderPayment;
  index: number;
  onAction: (action: Action, item: RenderPayment) => any;
}) => {
  const b = createBEM("i-payment-item");
  const payment = payments.find(payment => `${payment.value}` === `${item.type}`);
  const Component = useMemo(() => {
    return payment?.value ? paymentItemMap[payment.value] : null;
  }, [payment?.value]);
  return Component ? <div className={b()}>
      <SwipeAction rightActions={rightActions} onAction={action => onAction(action, item)}>
        <div className={cn(b("content"), `item-${payment?.value || ""}`, `item-bg${index % 6 || 0}`)}>
          <Component item={item} index={index} />
        </div>
      </SwipeAction>
    </div> : null;
};